import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Paths } from '~admin/route';
import { useModalControls } from '~common/hook/use-modal-controls';
import { Color } from '~common/model/basics';
import { YesNoDialog } from '~web/view/components/layout/yes-no-dialog.component';
import { Button } from '~common/components/button/button.component';
import { Size } from '~common/components/button/button.helper';
import { ExitIcon } from '~web/view/components/ui/icon/exit.icon';

export const LogoutButton: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [dialogShown, showDialog, hideDialog] = useModalControls();
  const history = useHistory();

  const onConfirm = (): void => {
    history.push(Paths.logout);
  };

  return (
    <>
      <Button onClick={showDialog} color={Color.DimGray} size={Size.Small}>
        <ExitIcon />
      </Button>
      {dialogShown && (
        <YesNoDialog
          title={t('logout.dialog.title')}
          yesLabel={t('logout.dialog.yes')}
          onYes={onConfirm}
          noLabel={t('logout.dialog.no')}
          onNo={hideDialog}
        />
      )}
    </>
  );
};



// WEBPACK FOOTER //
// ./view/components/auth/logout-button.component.tsx